import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettings, LandingPage } from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class LandingService {
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<LandingPage>(`${this.path}/landing-page`);
    }

    getAppSettings() {
        return this.http.get<Partial<AppSettings>>(`${this.path}/landing-page/app-settings`);
    }
}
